"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;

var _alert = require("./alert");

var _badge = require("./badge");

var _breadcrumb = require("./breadcrumb");

var _breadcrumbItem = require("./breadcrumbItem");

var _button = require("./button");

var _buttonGroup = require("./buttonGroup");

var _card = require("./card");

var _cardBody = require("./cardBody");

var _cardFooter = require("./cardFooter");

var _cardHeader = require("./cardHeader");

var _cardImageHeader = require("./cardImageHeader");

var _cardText = require("./cardText");

var _cardTitle = require("./cardTitle");

var _container = require("./container");

var _dropdownDivider = require("./dropdownDivider");

var _dropdownItem = require("./dropdownItem");

var _dropdownMenu = require("./dropdownMenu");

var _formCheck = require("./formCheck");

var _formCheckInput = require("./formCheckInput");

var _formControl = require("./formControl");

var _formControlPlainText = require("./formControlPlainText");

var _formGroup = require("./formGroup");

var _formText = require("./formText");

var _inputGroup = require("./inputGroup");

var _inputGroupText = require("./inputGroupText");

var _jumbotron = require("./jumbotron");

var _listGroup = require("./listGroup");

var _listGroupItem = require("./listGroupItem");

var _modalBody = require("./modalBody");

var _modalContent = require("./modalContent");

var _modalFooter = require("./modalFooter");

var _modalHeader = require("./modalHeader");

var _nav = require("./nav");

var _navLink = require("./navLink");

var _navbar = require("./navbar");

var _navbarLink = require("./navbarLink");

var _popover = require("./popover");

var _popoverArrow = require("./popoverArrow");

var _popoverBody = require("./popoverBody");

var _popoverHeader = require("./popoverHeader");

var _screenSize = require("./screenSize");

var _table = require("./table");

var _tr = require("./tr");

var _tooltip = require("./tooltip");

var _tooltipArrow = require("./tooltipArrow");

var _tooltipInner = require("./tooltipInner");

var _colorScheme = require("./colorScheme");

var _globals = require("./globals");

var theme = {
  colorScheme: _colorScheme.colorScheme,
  alert: _alert.alert,
  badge: _badge.badge,
  breadcrumb: _breadcrumb.breadcrumb,
  breadcrumbItem: _breadcrumbItem.breadcrumbItem,
  button: _button.button,
  buttonGroup: _buttonGroup.buttonGroup,
  card: _card.card,
  cardBody: _cardBody.cardBody,
  cardFooter: _cardFooter.cardFooter,
  cardHeader: _cardHeader.cardHeader,
  cardImageHeader: _cardImageHeader.cardImageHeader,
  cardText: _cardText.cardText,
  cardTitle: _cardTitle.cardTitle,
  container: _container.container,
  dropdownDivider: _dropdownDivider.dropdownDivider,
  dropdownItem: _dropdownItem.dropdownItem,
  dropdownMenu: _dropdownMenu.dropdownMenu,
  formCheck: _formCheck.formCheck,
  formCheckInput: _formCheckInput.formCheckInput,
  formControl: _formControl.formControl,
  formControlPlainText: _formControlPlainText.formControlPlainText,
  formGroup: _formGroup.formGroup,
  formText: _formText.formText,
  inputGroup: _inputGroup.inputGroup,
  inputGroupText: _inputGroupText.inputGroupText,
  jumbotron: _jumbotron.jumbotron,
  listGroup: _listGroup.listGroup,
  listGroupItem: _listGroupItem.listGroupItem,
  modalBody: _modalBody.modalBody,
  modalContent: _modalContent.modalContent,
  modalFooter: _modalFooter.modalFooter,
  modalHeader: _modalHeader.modalHeader,
  nav: _nav.nav,
  navLink: _navLink.navLink,
  navbar: _navbar.navbar,
  navbarLink: _navbarLink.navbarLink,
  popover: _popover.popover,
  popoverArrow: _popoverArrow.popoverArrow,
  popoverBody: _popoverBody.popoverBody,
  popoverHeader: _popoverHeader.popoverHeader,
  screenSize: _screenSize.screenSize,
  table: _table.table,
  tr: _tr.tr,
  tooltip: _tooltip.tooltip,
  tooltipArrow: _tooltipArrow.tooltipArrow,
  tooltipInner: _tooltipInner.tooltipInner,
  globals: _globals.globals
};
exports.theme = theme;